<template>
  <div>
    <vuex-table :fields="fields" table_store="projects/table">
      <template #actions="{ item }">
        <tooltip
          :content="$t('projects.imports.field.title')"
          theme="light"
          :transfer="true"
          placement="top"
          class="text-left tooltip-project"
        >
          <table-control
            v-if="user.role != 'user'"
            type="import"
            :title="$t('projects.table.btn_type.import')"
            @click="goImport(item)"
          />
        </tooltip>
        <tooltip
          :content="$t('projects.table.btn_type.list')"
          theme="light"
          :transfer="true"
          placement="top"
          class="text-left tooltip-project"
        >
          <table-control
            type="list"
            :title="$t('projects.table.btn_type.list')"
            @click="taskList(item)"
          />
        </tooltip>
        <tooltip
          v-if="user.role != 'user'"
          :content="$t('projects.table.btn_type.edit')"
          theme="light"
          :transfer="true"
          placement="top"
          class="text-left tooltip-project"
        >
          <table-control
            type="edit"
            :title="$t('projects.table.btn_type.edit')"
            @click="edit(item)"
          />
        </tooltip>
        <!-- <table-control type="stats" :title="$t('projects.table.btn_type.stats')" @click="stats(item)" />-->
      </template>
    </vuex-table>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  // import { ProjectsService } from '@projects/services/ProjectsService';

  export default {
    computed: {
      ...mapGetters('core/auth', ['user']),
      fields() {
        return [
          {
            key: 'id',
            label: this.$t('projects.table.field.id'),
            thStyle: { width: '20px' }
          },
          {
            key: 'name',
            label: this.$t('projects.table.field.name')
          },
          {
            key: 'created_at',
            label: this.$t('projects.table.field.created_at'),
            thStyle: { width: '200px' }
          },
          {
            key: 'tasks_count',
            label: this.$t('projects.table.field.total_task'),
            thStyle: { width: '120px' }
          },
          {
            key: 'tasks_today_count',
            label: this.$t('projects.table.field.task_today'),
            thStyle: { width: '140px' }
          },
          {
            key: 'sources_count',
            label: this.$t('projects.table.field.source'),
            thStyle: { width: '120px' }
          },
          {
            key: 'actions',
            label: '',
            class: 'text-right',
            thStyle: { width: '200px' }
          }
        ];
      }
    },
    methods: {
      ...mapActions('projects/table', ['getAsyncData']),

      goImport(item) {
        this.$router.push({
          name: 'projects.import.create',
          params: {
            id: item.id,
            edit: true
          }
        });
      },
      taskList(item) {
        this.$router.push({ name: 'projects.tasks.list', params: { project_id: item.id } });
      },
      edit(item) {
        this.$router.push({ name: 'projects.edit', params: { id: item.id } });
      },

      stats(id) {
        console.log(id);
      }
    }
  };
</script>

<style lang="scss">
  .ivu-tooltip-inner {
    min-width: 80px;
    font-family: 'Lato';
  }
  .tooltip-project {
    position: relative;
    .ivu-tooltip-content {
      width: 100%;
    }
    &:nth-child(1) {
      .ivu-tooltip-content {
        min-width: 115px;
      }
    }
    &:nth-child(2) {
      .ivu-tooltip-content {
        min-width: 168px;
      }
    }
    &:nth-child(3) {
      .ivu-tooltip-content {
        min-width: 170px;
      }
    }
  }
</style>
